module.exports = __webpack_public_path__ + "img/rainbow.6bbc5168.svg";